export function html(strings: TemplateStringsArray) {
  return String.raw({ raw: strings });
}
